<script>
import Datepicker from 'vuejs-datepicker';
export default {
    name: 'Datepicker',
    mixins: [Datepicker]
}
</script>
<style lang="scss">
  .vdp-datepicker__calendar {
    border: 1px solid $gray-400;

    header {
      .next {
        &:after {
          border-left-color: $dark;
        }
        &.disabled:after {
          border-left-color: $gray-300;
        }
      }
      .prev {
        &:after {
          border-right-color: $dark;
        }
        &.disabled:after {
          border-right-color: $gray-300;
        }
      }

      .up:not(.disabled) {
        &:hover {
          background: $gray-200;
        }
      }
    }

    .disabled {
      color: $gray-300;
    }

    .cell {
      &:not(.blank):not(.disabled).day,
      &:not(.blank):not(.disabled).month,
      &:not(.blank):not(.disabled).year {
        &:hover {
          border-color: lighten($primary, 20);
        }
      }

      &.selected {
        background: $primary;
        color: $white;
        &:hover {
          background: $primary;
          color: $white;
        }
        &.highlighted {
          background: $primary;
          color: $white;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/_eng/globals/_datepicker.vue